import {Filter} from '../components/pages/transactions/TransactionsPartialFilter/TransactionsPartialFilter';
import buildQuery from '../utils/router/buildQuery';
import {ApiClientInterface} from './clients';
import {Collection, Money, ReferralUserList, UuidResult, WithdrawRequest} from './models';

export class ReferralManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async sendCode(confirmationUuid?: string): Promise<UuidResult> {
    return this.apiClient.post('send-code', confirmationUuid ? {confirmationUuid} : {});
  }

  public async confirmCode(confirmationUuid: string, smsCode: string): Promise<void> {
    return this.apiClient.post('confirm-code', {confirmationUuid, smsCode});
  }

  public async enableReferral(): Promise<void> {
    return this.apiClient.post('enable-referral');
  }

  public async isReferralEnabled(): Promise<boolean> {
    return this.apiClient.get('referral-enabled');
  }

  getWithdrawList(page = 1, perPage = 25): Promise<Collection<WithdrawRequest>> {
    const query = buildQuery({page, perPage});
    return this.apiClient.get(`/withdraw/?${query}`);
  }

  getUserList(page = 1, perPage = 25, filter?: Filter): Promise<ReferralUserList> {
    const query = buildQuery({page, perPage, filter});
    return this.apiClient.get(`/user/?${query}`);
  }

  create(money: Money): Promise<UuidResult> {
    return this.apiClient.post('/withdraw/', {money});
  }

  cancel(uuid: string): Promise<void> {
    return this.apiClient.post(`/withdraw/${uuid}/cancel`);
  }
}
